module.exports = __webpack_public_path__ + "static/media/darkness-lose.28efdbb2.png";